import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { fromAccounts, fromSurvey } from '../../../../store';
import { SurveyName } from '../../../../models';
import { LoadingProgress } from '../../../../layout';
import { useQuery } from '../../../../routes';

interface SurveyIframeProps {
  handleSurveyClose: (action: SurveyAction) => void,
}

interface SurveyMessageResponse {
  action: SurveyAction;
}

export enum SurveyAction {
  FINISH = 'finish',
  CANCEL = 'cancel',
}

const SurveyIframe = (props: SurveyIframeProps) => {
  const {
    handleSurveyClose,
  } = props;
  const { get } = useQuery();
  const accountId = get('accountId');
  const ref = useRef<HTMLIFrameElement>(null);
  const [isLoading, setIsLoading] = useState(true);
  const salesforceLinkedAccount = useSelector(fromAccounts.selectSalesforceAccount);

  const {
    surveyURL,
  } = useSelector(fromSurvey.selectSurvey(SurveyName.TURN_OFF_AUTO_RENEW_SURVEY))!!;

  useEffect(() => {
    const handleMessage = (message: MessageEvent<SurveyMessageResponse>) => {
      if (message.data.action === SurveyAction.FINISH) {
        handleSurveyClose(SurveyAction.FINISH);
      } else if (message.data.action === SurveyAction.CANCEL) {
        handleSurveyClose(SurveyAction.CANCEL);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const handleIframeError = () => {
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <LoadingProgress />}
      <iframe
        title="Survey"
        src={`${surveyURL}&account_id=${accountId}&sf_account_id=${salesforceLinkedAccount?.id || ''}`}
        width="100%"
        height="100%"
        ref={ref}
        style={{
          border: '1px solid #FFFFFF',
          borderRadius: '8px',
          display: isLoading ? 'none' : 'block',
        }}
        onLoad={handleIframeLoad}
        onError={handleIframeError}
      />
    </>
  );
};

export default SurveyIframe;
